<app-navbar></app-navbar>

<section class="min-h-[50dvh] bg-black text-black">
  
    <div class="w-full">
        <div class="hero min-h-[60dvh]" style="background-image: url(/assets/img/excellence/awards/672a3666eafd645a5bd609e5_prinx-awards-new.png);">
            <div class="hero-overlay"></div>
            <div class="text-neutral-content text-center">
                <div class="max-w-5xl">
                    <h3 class="text-3xl font-bold uppercase mx-auto">{{texts.title[0]}} <br><span class="text-green-500">{{texts.title[1]}}</span></h3>
                    <p class="text-base md:w-3/5 mx-auto">{{texts.subtitle[0]}}</p>
                    <p class="text-base md:w-3/5 mt-4 mx-4 md:mx-auto">{{texts.subtitle[1]}}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full">
        <div class="hero min-h-[60dvh]" style="background-image: url(/assets/img/excellence/awards/1.png);">
            <div class="hero-overlay"></div>
            <div class="text-neutral-content text-left">
                <div class="max-w-6xl">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 rounded-lg p-8">
                        <div class="flex flex-col items-center justify-center border-2 border-green-500 p-3 rounded-2xl relative overflow-hidden">
                            <div class="absolute inset-0 z-0 backdrop-blur-md"></div>
                            <img src="/assets/img/excellence/awards/672b26acaf5e5e0a8bec776f_award-italy-p-500.png" alt="Premio Red Dot" class="m-2 items-center w-3/4 relative z-10" />
                        </div>
                        <div class="flex flex-col justify-center items-center">
                            <div>
                                <h3 class="font-bold text-3xl uppercase">{{texts.premios[0].title}}</h3>
                                <div class="mt-4">
                                    <p class="text-xl uppercase">{{texts.premios[0].position}}</p>
                                    <p class="text-2xl text-green-500 uppercase">{{texts.premios[0].tire}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-base">{{texts.premios[0].place}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-lg uppercase">{{texts.categoria}}</p>
                                    <p class="text-sm uppercase">{{texts.premios[0].category_name}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-sm">{{texts.premios[0].description}}</p>
                                </div>
                            </div>
                            <a href="https://competition.adesignaward.com/design.php?ID=139443" target="_blank" rel="noopener noreferrer" class="mt-4 w-40 inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide  
                            border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 
                            hover:border-green-600 hover:text-green-600 hover:scale-110 transition-transform duration-200 hover:bg-black">
                                <span>{{texts.ver_premio}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full">
        <div class="hero min-h-[60dvh]" style="background-image: url(/assets/img/excellence/awards/2.png);">
            <div class="hero-overlay"></div>
            <div class="text-neutral-content text-left">
                <div class="max-w-6xl">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 rounded-lg p-8">
                        <div class="flex flex-col items-center justify-center border-2 border-green-500 p-3 rounded-2xl relative overflow-hidden">
                            <div class="absolute inset-0 z-0 backdrop-blur-md"></div>
                            <img src="/assets/img/excellence/awards/672b2695037ea44b994432f9_award-paris-p-500.png" alt="Premio Red Dot" class="m-2 items-center w-3/4 relative z-10" />
                            
                        </div>
                        <div class="flex flex-col justify-center items-center">
                            <div>
                                <h3 class="font-bold text-3xl uppercase">{{texts.premios[1].title}}</h3>
                                <div class="mt-4">
                                    <p class="text-xl uppercase">{{texts.premios[1].position}}</p>
                                    <p class="text-2xl text-green-500 uppercase">{{texts.premios[1].tire}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-base">{{texts.premios[1].place}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-lg uppercase">{{texts.categoria}}</p>
                                    <p class="text-sm uppercase">{{texts.premios[1].category_name}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-sm">{{texts.premios[1].description}}</p>
                                </div>
                            </div>
                            
                            <a href="https://cdn.prod.website-files.com/65379f6a9f143ec19d8f22b6/655ce0e04b2e0bbfb915d380_certificate_22.pdf" target="_blank" rel="noopener noreferrer" class="mt-4 w-40 inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide  
                            border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 
                            hover:border-green-600 hover:text-green-600 hover:scale-110 transition-transform duration-200 hover:bg-black">
                                <span>{{texts.ver_premio}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full">
        <div class="hero min-h-[60dvh]" style="background-image: url(/assets/img/excellence/awards/3.png);">
            <div class="hero-overlay"></div>
            <div class="text-neutral-content text-left">
                <div class="max-w-6xl">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 rounded-lg p-8">
                        <div class="flex flex-col items-center justify-center border-2 border-green-500 p-3 rounded-2xl relative overflow-hidden">
                            <div class="absolute inset-0 z-0 backdrop-blur-md"></div>
                            <img src="/assets/img/excellence/awards/672b269f234e1fd857f7628c_award-muse-p-500.png" alt="Premio Red Dot" class="m-2 items-center w-3/4 relative z-10" />
                            
                        </div>
                        <div class="flex flex-col justify-center items-center">
                            <div>
                                <h3 class="font-bold text-3xl uppercase">{{texts.premios[2].title}}</h3>
                                <div class="mt-4">
                                    <p class="text-xl uppercase">{{texts.premios[2].position}}</p>
                                    <p class="text-2xl text-green-500 uppercase">{{texts.premios[2].tire}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-base">{{texts.premios[2].place}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-lg uppercase">{{texts.categoria}}</p>
                                    <p class="text-sm uppercase">{{texts.premios[2].category_name}}</p>
                                </div>
                                <div class="mt-2">
                                    <p class="text-sm">{{texts.premios[2].description}}</p>
                                </div>
                            </div>
                            
                            <a href="https://design.museaward.com/winner-info.php?id=7551" target="_blank" rel="noopener noreferrer" class="mt-4 w-40 inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide  
                            border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 
                            hover:border-green-600 hover:text-green-600 hover:scale-110 transition-transform duration-200 hover:bg-black">
                                <span>{{texts.ver_premio}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</section>

<app-footer></app-footer>